import Layout from "@/layout/index.vue";

export default {
  path: "",
  component: Layout,
  meta: { title: "选品中心" },
  children: [
    {
      path: "/productSelectionCenter/purchase",
      component: () =>
        import("@/pages/productSelectionCenter/purchase/purchase.vue"),
      meta: {
        title: "采购商管理",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/pageManager",
      component: () =>
        import("@/pages/productSelectionCenter/pageManager/pageManager.vue"),
      meta: {
        title: "商品管理",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/brandManager",
      component: () =>
        import("@/pages/productSelectionCenter/brandManager/brandManager.vue"),
      meta: {
        title: "品牌管理",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/configManager",
      component: () =>
        import(
          "@/pages/productSelectionCenter/configManager/configManager.vue"
        ),
      meta: {
        title: "配置管理",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/supply-demand-hall",
      component: () =>
        import("@/pages/productSelectionCenter/供需大厅管理/index.vue"),
      meta: {
        title: "供需大厅管理",
      },
    },
    {
      path: "/productSelectionCenter/hometjManager",
      component: () =>
        import(
          "@/pages/productSelectionCenter/hometjManager/hometjManager.vue"
        ),
      meta: {
        title: "首页推荐管理",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/hometjManager-Phase2",
      component: () =>
        import("@/pages/productSelectionCenter/首页推荐管理二期/index.vue"),
      meta: {
        title: "首页推荐管理二期",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/recommendPool",
      component: () =>
        import(
          "@/pages/productSelectionCenter/recommendPool/RecommendPool.vue"
        ),
      meta: {
        title: "选品中心推荐池",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/recommendTags",
      component: () =>
        import("@/pages/productSelectionCenter/推荐标签管理/index.vue"),
      meta: {
        title: "推荐标签管理",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/intentionOrder",
      component: () =>
        import("@/pages/productSelectionCenter/intentionOrder/index.vue"),
      meta: {
        title: "意向单管理",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/areaManager",
      component: () =>
        import("@/pages/productSelectionCenter/areaManager/areaManager.vue"),
      meta: {
        title: "专区管理",
        icon: "iconcaiwurenminbizhifux",
      },
    },
    {
      path: "/productSelectionCenter/areaManager/goodsManager",
      component: () =>
        import("@/pages/productSelectionCenter/areaManager/goodsManager.vue"),
      meta: {
        title: "管理商品",
      },
    },
    {
      path: "/productSelectionCenter/hometjManager-Phase2/goods-manager",
      name: "goods-manager",
      component: () =>
        import(
          "@/pages/productSelectionCenter/首页推荐管理二期/goods-manager.vue"
        ),
      meta: {
        title: "商品管理",
      },
    },
  ],
};
